module.exports = __webpack_public_path__ + "pw.667ce732.svg";